import { fetchAllAdminFormsApplications } from '../../../../lib/fetchers';
import React from 'react';
import AdminPreviewApplications from '..';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';

function SmartIndexForms() {
  const [isLoading, setIsLoading] = React.useState<boolean>(true);
  const [applications, setApplications] = React.useState<any>([]);
  const [applicationsCount, setApplicationsCount] = React.useState<number>(0);
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();

  const [page_length, setPageSize] = React.useState(10);
  const [page, setPage] = React.useState(0);


  const fetching = async () => {
    try {
      setIsLoading(true);
      const data = await fetchAllAdminFormsApplications({page_length, page});      
      setApplications(data.data);
      setApplicationsCount(data.total_count);
    } catch (error) {
      console.error(error);
      enqueueSnackbar(t('Παρουσιάστηκε κάποιο σφάλμα'), { variant: 'error' });
    }
    setIsLoading(false);
  };

  React.useEffect(() => {
    fetching();
  }, [page_length, page]);


  return (<>
    <AdminPreviewApplications
      total_count={applicationsCount}
      applications={applications} 
      isLoading={isLoading}
      _pageSize={page_length}
      _page={page}
      setPageSize={setPageSize}
      setPage={setPage}/>
  </>);
}

export default SmartIndexForms;